import React from 'react';
import { connect } from 'react-redux';
import { Loading } from '../UI/Loading';
import { WordSearchListItem } from './WordSearchListItem';
import { updateWordSearchStatus, deleteWordSearch, } from '../../redux/actions/word-searches';
const WordSearchListComponent = ({ loading, wordSearches, layout, deleteWordSearch, updateWordSearchStatus, error, errorDetail, }) => {
    const handleDeleteWordSearch = (wordSearchId) => {
        deleteWordSearch(wordSearchId);
    };
    const handleStatusUpdate = (wordSearchId, status) => {
        updateWordSearchStatus({ wordSearchId, status });
    };
    return error ? (React.createElement("div", null, errorDetail)) : loading ? (React.createElement(Loading, null)) : wordSearches.length < 1 ? (React.createElement("div", { style: {
            width: '70%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
        } },
        React.createElement("p", { style: { textAlign: 'center', color: 'grey' } }, "Wow, such emptiness. Why don't you create a new wordSearch. :)"))) : (React.createElement("div", { className: layout === 'Grid' ? 'activity-grid' : 'activity-list' }, wordSearches.map((wordSearch) => (React.createElement(WordSearchListItem, { key: wordSearch.wordSearchId, wordSearch: wordSearch, onDelete: handleDeleteWordSearch, onStatusUpdate: handleStatusUpdate })))));
};
const mapStateToProps = (state) => ({
    loading: state.wordSearchState.loading,
    error: state.wordSearchState.error,
    errorDetail: state.wordSearchState.errorDetail,
});
const mapDispatchToProps = {
    updateWordSearchStatus,
    deleteWordSearch,
};
export const WordSearchList = connect(mapStateToProps, mapDispatchToProps)(WordSearchListComponent);
